import { use } from 'react'

import { DialogData, DialogRouterContext, DialogState, DialogType } from './DialogRouterContext'

export const useDialogRouter = () => use(DialogRouterContext)

// small helper to conditionally add optional dialogData parameter,
// such that dialogs without data does not need to call eg. open(undefined)
type BoundOpenDialogFn<T extends DialogType> =
    undefined extends DialogData<T> ? () => void : (dialogData: DialogData<T> extends undefined ? undefined : DialogData<T>) => void

export const useDialog = <T extends DialogType>(dialog: T) => {
    const { activeDialog, setDialog, closeDialog } = useDialogRouter()

    const openDialog: BoundOpenDialogFn<T> = (dialogData?: DialogData<T>) => setDialog({ activeDialog: dialog, dialogData } as DialogState<T>)

    return {
        isOpen: activeDialog === dialog,
        openDialog,
        closeDialog,
    }
}

export const useOpenDialog = <T extends DialogType>(dialog: T): BoundOpenDialogFn<T> => {
    const { setDialog } = useDialogRouter()

    return (dialogData?: DialogData<T>) => setDialog({ activeDialog: dialog, dialogData } as DialogState<T>)
}

export const useSetDialog = () => useDialogRouter().setDialog
